import Overview from "@/components/admin/Content/WebPages/ProgrammesAndInitiatives/StrategicPillars/Overview";
import HeroSection from "@/components/admin/Content/WebPages/ProgrammesAndInitiatives/StrategicPillars/HeroSection";
import FullPageSpinner from "@/components/ui/FullPageSpinner";
import { useWebPageForm } from "@/contexts/WebPageFormContext";

const StrategicPillars = () => {
  const { pageData, isLoading } = useWebPageForm();

  if (isLoading) {
    return <FullPageSpinner />
  }

  return (
    <div className="flex flex-col gap-8 lg:gap-12 p-4 md:p-8 lg:p-12 xl:w-3/4 mx-auto">
      <HeroSection data={pageData?.STRATEGIC_PILLAR_BANNER ?? {
        sectionTag: 'STRATEGIC_PILLAR_BANNER',
        contentType: 'WITH_FILE',
        title: 'Strategic Pillars Banner',
        description: 'Banner for the strategic pillars page'
      }} />
      <Overview data={pageData?.STRATEGIC_PILLARS ?? {
        sectionTag: 'STRATEGIC_PILLARS',
        contentType: 'WITHOUT_FILE',
        sectionTitle: 'Strategic Pillars',
        title: 'Our Strategic Pillars'
      }} />
    </div>
  )
}

export default StrategicPillars